import React from "react";

const RoomDetails = () => {
  return (
    <div className="flex justify-center font-hk mt-4">
      <div className="p-4 w-[90vw] px-3  bg-[#f1f1f1]  rounded-lg shadow-lg ">
        <h2 className="text-xl font-semibold mb-4">Room Type & Details</h2>
        <div className="flex flex-row">
          <div className="w-3/12 bg-none flex justify-center border-black border-r">
            <div className="bg-gray-400">Room Type</div>
          </div>
          <div className="w-1/12 bg-slate-500 flex flex-col justify-center border-black border-r">
            <div className="bg-gray-400">Sleeps</div>
            <div className="flex flex-col h-[400px] justify-center">
              <div className="h-1/2 border-b-2 border-black">
                Deluxe room with balcony
              </div>
              <div className="h-1/2">Deluxe room with balcony</div>
            </div>
          </div>
          <div className="w-3/12 bg-slate-500 flex flex-col justify-center border-black border-r">
            <div className="bg-gray-400">Room Options</div>
            <div className="flex flex-col h-[400px] justify-center">
              <div className="h-1/2 border-b-2 border-black">
                Deluxe room with balcony
              </div>
              <div className="h-1/2">Deluxe room with balcony</div>
            </div>
          </div>
          <div className="w-3/12 bg-slate-500 flex flex-col justify-center border-black border-r">
            <div className="bg-gray-400">Inclusions</div>
            <div className="flex flex-col h-[400px] justify-center">
              <div className="h-1/2 border-b-2 border-black">
                Deluxe room with balcony
              </div>
              <div className="h-1/2">Deluxe room with balcony</div>
            </div>
          </div>
          <div className="w-3/12 bg-slate-500 flex flex-col justify-center border-black ">
            <div className="bg-gray-400">Price</div>
            <div className="flex flex-col h-[400px] justify-center">
              <div className="h-1/2 border-b-2 border-black">
                Deluxe room with balcony
              </div>
              <div className="h-1/2">Deluxe room with balcony</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomDetails;
